import React, { useState } from 'react';
import { signUp } from '../../auth/authService';
import { useAuthDispatch } from '../../auth/authContext';
import { SIGNING_UP } from '../../auth/authTypes';
import Monitor, { FingerPrint } from '../../lib/monitoring/Monitor';
import AppAnalytics, {
  GaCategories,
  GaActions,
} from '../../lib/analytics/Analytics';
import SignUpScreen from './screen';

const SignUpScreenContainer = ({ navigation }) => {
  const dispatch = useAuthDispatch();
  const [signUpError, setSignUpError] = useState('');
  const [signUpLoading, setSignUpLoading] = useState(false);

  const setMonitorError = (message, userType = '', email = '') => {
    return {
      context: { user_email: email, user_type: userType },
      name: 'SignUp',
      fingerprint: FingerPrint.auth,
      message,
    };
  };
  const getErrorMessages = (error) => {
    const defaultErrorMessage = 'There has been an issue please try again';
    if (error && error.message) {
      return error.message;
    }
    return defaultErrorMessage;
  };

  const signUpUser = ({
    email,
    password,
    fullName,
    userType,
    agreedToTerms,
  }) => {
    const lowerCasedEmail = email.toLowerCase();
    setSignUpLoading(true);
    setSignUpError('');
    signUp(lowerCasedEmail, password, fullName, userType, agreedToTerms)
      .then(() => {
        const user = {
          email: lowerCasedEmail,
          password,
        };
        AppAnalytics.sendEvent(GaCategories.SIGNUP, GaActions.CREATE, 110);
        dispatch({ type: SIGNING_UP, ...user });
        navigation.navigate('VerifyUser');
        setSignUpLoading(false);
      })
      .catch((err) => {
        setSignUpLoading(false);
        const errorMessage = getErrorMessages(err);
        setSignUpError(errorMessage);
        Monitor.notify(
          err,
          setMonitorError(
            'Error while user signing up, signUpUser function',
            userType,
            lowerCasedEmail,
          ),
        );
        console.error(err);
      });
  };

  return (
    <SignUpScreen
      navigation={navigation}
      signUpUser={signUpUser}
      signUpError={signUpError}
      signUpLoading={signUpLoading}
    />
  );
};

export default SignUpScreenContainer;
